import(/* webpackMode: "eager", webpackExports: ["Photo"] */ "/home/runner/work/brics-website/brics-website/entities/article/ui/photo/photo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Quote"] */ "/home/runner/work/brics-website/brics-website/entities/article/ui/quote/quote.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/entities/block-documents/document/document.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/entities/block-documents/block-documents.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["ImageSlider"] */ "/home/runner/work/brics-website/brics-website/entities/image-slider/image-slider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ReadMore"] */ "/home/runner/work/brics-website/brics-website/entities/read-more/read-more.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brics-website/brics-website/node_modules/next-intl/dist/esm/navigation/shared/BaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brics-website/brics-website/node_modules/next-intl/dist/esm/navigation/shared/LegacyBaseLink.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/home/runner/work/brics-website/brics-website/node_modules/next-intl/dist/esm/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/node_modules/next/dist/client/image-component.js");
;
import(/* webpackMode: "eager", webpackExports: ["Founders"] */ "/home/runner/work/brics-website/brics-website/sections/founders/founders.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Institutions"] */ "/home/runner/work/brics-website/brics-website/sections/institutions/institutions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Persons"] */ "/home/runner/work/brics-website/brics-website/sections/persons/persons.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["TextCardList"] */ "/home/runner/work/brics-website/brics-website/sections/text-card-list/text-card-list.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/sections/workgroup-experts/workgroup-experts.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Accordion"] */ "/home/runner/work/brics-website/brics-website/shared/ui/accordion/accordion.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Disclaimer"] */ "/home/runner/work/brics-website/brics-website/shared/ui/disclaimer/disclaimer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HeaderPage"] */ "/home/runner/work/brics-website/brics-website/shared/ui/header-page/header-page.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/ui/member/member.module.scss");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/app/[locale]/workgroup/[slug]/page.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["RichTextHighlight"] */ "/home/runner/work/brics-website/brics-website/shared/ui/rich-text-highlight/rich-text-highlight.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RichText"] */ "/home/runner/work/brics-website/brics-website/shared/ui/rich-text/rich-text.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/ui/source/source.module.scss");
;
import(/* webpackMode: "eager", webpackExports: ["Table"] */ "/home/runner/work/brics-website/brics-website/shared/ui/table/table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Text"] */ "/home/runner/work/brics-website/brics-website/shared/ui/text/text.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Timeline"] */ "/home/runner/work/brics-website/brics-website/shared/ui/timeline/timeline.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["VideoCard"] */ "/home/runner/work/brics-website/brics-website/shared/ui/video-card/video-card.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Workgroups"] */ "/home/runner/work/brics-website/brics-website/shared/ui/workgroups/workgroups.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/common.js");
;
import(/* webpackMode: "eager" */ "/home/runner/work/brics-website/brics-website/shared/utils/hooks.tsx");
